"use client";

import type { PadelTemplateData } from "../padel-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type PadelDisplayPreviewProps = {
  data: PadelTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function PadelDisplayPreview({
  data,
  participants,
}: PadelDisplayPreviewProps) {
  if (!data) {
    return (
      <ActivityCourtPreview
        activityId="padel"
        yourTeam={[]}
        opponentTeam={[]}
      />
    );
  }

  const yourTeam = participants
    .filter((p) => data.positions[p.id] === "your-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));
  const opponentTeam = participants
    .filter((p) => data.positions[p.id] === "opponent-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));

  const showScore = data.hasScore !== false;
  const yourWon = data.matchScore.yourSets > data.matchScore.opponentSets;

  return (
    <div>
      <ActivityCourtPreview
        activityId="padel"
        data={data}
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        showLabels={false}
        linkToProfiles
      />
    </div>
  );
}
